import { atom } from 'jotai';
import { $ArticleCommentDetail, IArticleCommentDetail } from './article-comment-detail';
import { safeAtomFamily } from 'shared/utils/safe-atom-family';

export const $ArticleCommentDetailLoadmore = safeAtomFamily((commentId: string) => {
  const a = atom(null, (get, set, input: IArticleCommentDetail) => {
    const commentDetail = get($ArticleCommentDetail(commentId));
    const { replies } = commentDetail;
    const { hasMore, replies: nextReplies, cursor } = input;

    set($ArticleCommentDetail(commentId), {
      hasMore,
      replies: [...replies, ...nextReplies],
      cursor,
    });
  });

  a.debugLabel = `$ArticleCommentDetailLoadmore+${encodeURIComponent(commentId)}`;

  return a;
});
